<template>
  <div>
    <v-toolbar flat dark>
      <v-toolbar-title>Form Fill Up Fee (University)</v-toolbar-title>
    </v-toolbar>
    <table
      class="v-datatable v-table theme--light"
      v-if="getStudentFormFillUpFees.hasOwnProperty('fees')"
    >
      <tbody>
        <slot v-for="(item, index) in getStudentFormFillUpFees.fees">
          <tr :key="index" v-if="item.iteration">
            <th
              role="columnheader"
              scope="col"
              aria-label="Dessert (100g serving): Not sorted."
              aria-sort="none"
              class="column text-xs-left"
            >
              {{ item.fee_title }}
            </th>
            <td class="text-xs-right">
              {{
                `${item.amount}x${item.iteration}=${convertFloat(
                  item.iteration * item.amount,
                )}`
              }}
            </td>
          </tr>
        </slot>

        <tr v-if="getStudentFormFillUpFees.total > 0">
          <th
            role="columnheader"
            scope="col"
            aria-label="Dessert (100g serving): Not sorted."
            aria-sort="none"
            class="column text-xs-left"
          >
            Total
          </th>
          <td class="text-xs-right">
            {{ convertFloat(getStudentFormFillUpFees.total) }}
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-if="
        getStudentFormFillUpSubject.form_fill_up &&
          getStudentFormFillUpSubject.form_fill_up.is_july_fighter == true
      "
      class="july-fighter-notice"
    >
      <v-icon class="july-fighter-notice__icon">mdi-alert-decagram</v-icon>
      <div class="july-fighter-notice__text">
        <p>
          "আপনি জুলাই যোদ্ধা হিসেবে ফি মওকুফের সুবিধা পাবেন। অনুগ্রহ করে আবেদনটি
          সম্পন্ন করুন। প্রযোজ্য ফি মওকুফ স্বয়ংক্রিয়ভাবে আবেদনের সঙ্গে যুক্ত
          হবে এবং আবেদন ফরমে প্রদর্শিত হবে।"
        </p>
      </div>
    </div>

    <!--<pre>{{getStudentFormFillUpFees}}</pre> -->
    <!-- <pre>{{getStudentFormFillUpSubject}}</pre> -->
  </div>
</template>
<script>
export default {
  name: "FormFillUpFee",
  created() {
    // this.calculateFee();
  },
  computed: {
    profile() {
      let profile = JSON.parse(localStorage.getItem("student"));
      return profile;
    },
    getStudentFormFillUpFees() {
      return this.$store.getters.getStudentFormFillUpFees;
    },
    getStudentFormFillUpSubject() {
      return this.$store.getters.getStudentFormFillUpSubject;
    },
  },
  data() {
    return {
      //   form_fill_up_fee: {}
    };
  },
  methods: {
    convertFloat(val) {
      let value = Number(val);
      return value.toFixed(2);
    },
  },
};
</script>

<style scoped>
.july-fighter-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 16px;
  padding: 16px 18px;
  border-radius: 10px;
  background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
  border-left: 5px solid #f9a825;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  animation: july-fighter-fade-in 0.4s ease-out;
}

.july-fighter-notice__icon {
  color: #f9a825 !important;
  font-size: 28px !important;
  flex-shrink: 0;
  margin-top: 2px;
}

.july-fighter-notice__text p {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.7;
  color: #005d1c;
}

@keyframes july-fighter-fade-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
